const getBaseUrl = () => {
  // In development, use the Vite proxy to avoid CORS issues
  if (import.meta.env.DEV) {
    return '/api'; // This will be proxied to http://localhost:8000
  }
  
  // In production, use the environment variable or dynamically detect the current origin
  if (import.meta.env.VITE_API_BASE_URL) {
    return import.meta.env.VITE_API_BASE_URL;
  }
  
  // Fallback: use current window location (same domain as frontend)
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  
  // Final fallback for SSR or build time
  return 'http://localhost:8000';
};

export const BASE_URL = getBaseUrl();

export const API_ENDPOINTS = {
  auth: {
    login: `${BASE_URL}/auth/login`,
    callback: `${BASE_URL}/auth/callback/azure`,
    logout: `${BASE_URL}/auth/logout`,
    check: `${BASE_URL}/auth/check`,
    refresh: `${BASE_URL}/auth/refresh`,
    me: `${BASE_URL}/me`,
  },
  conversations: {
    list: `${BASE_URL}/conversations`,
    start: `${BASE_URL}/conversations/start`,
    getById: (conversationId: string) => `${BASE_URL}/conversations/${conversationId}`,
    sendMessage: (conversationId: string) => `${BASE_URL}/conversations/${conversationId}/messages`,
    regenerate: (conversationId: string) => `${BASE_URL}/conversations/${conversationId}/regenerate`,
    delete: (conversationId: string) => `${BASE_URL}/conversations/${conversationId}`,
    rename: (conversationId: string) => `${BASE_URL}/conversations/${conversationId}`,
  },
  messages: {
    feedback: (messageId: string) => `${BASE_URL}/messages/${messageId}/feedback`,
  },
  feedback: {
    global: `${BASE_URL}/feedback`,
  },
  // ... other endpoints can be added here
};
